import { useLocation } from 'react-router-dom';

import PipelineMessage from './PipelineMessage';
import ProcessingPipeline from './ProcessingPipeline';
import { DurationEstimate, RunStatus } from '../../../../../../../backend/src/types/types';
import { DocumentUploadCompleteOnboardingModal } from '@/components/molecules/Modals/Onboarding/DocumentUploadOnboardingModal';

interface StatusDisplayProps {
  casePipelineStatus: RunStatus;
  runId: string;
  completedAtEstimate?: Date | null;
  pageEstimate?: number;
  durationEstimate?: DurationEstimate | null;
}

const StatusDisplay = ({
  casePipelineStatus,
  runId,
  completedAtEstimate,
  pageEstimate,
  durationEstimate,
}: StatusDisplayProps) => {
  const { state } = useLocation();
  const fromChecklistDocumentUpload = state?.fromChecklistDocumentUpload;

  const isFailed = casePipelineStatus === RunStatus.Failed;

  return (
    <div className="border-opacity-40 my-4 rounded-lg border-2 border-gray-200 bg-white p-8 pt-4">
      <h2 className="mb-2 flex w-full items-center gap-2 border-b pb-1 text-xl font-semibold">Processing Case</h2>
      <div className="py-2">
        <PipelineMessage
          isFailed={isFailed}
          pageCount={pageEstimate}
          completedAtEstimate={completedAtEstimate}
          durationEstimate={durationEstimate}
          status={casePipelineStatus}
        />
        {!isFailed && (
          <ProcessingPipeline
            casePipelineStatus={casePipelineStatus}
            runId={runId}
            pageCount={pageEstimate}
            durationEstimate={durationEstimate}
          />
        )}
        {fromChecklistDocumentUpload && <DocumentUploadCompleteOnboardingModal />}
      </div>
    </div>
  );
};

export default StatusDisplay;
